import * as React from "react";
import { ActiveIconProps } from "../../../interface/activeicon.interface";

export const EmailIcon: React.FC<ActiveIconProps> = ({ isActive }) =>
  isActive ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      fill="none"
      viewBox="0 0 22 20"
    >
      <g
        id="Message"
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          id="Stroke 1"
          d="m16.902 6.851-4.443 3.613c-.84.666-2.02.666-2.86 0l-4.48-3.613"
        ></path>
        <path
          id="Stroke 3"
          fillRule="evenodd"
          d="M15.909 19C18.95 19.008 21 16.51 21 13.438V6.57C21 3.499 18.95 1 15.909 1H6.09C3.05 1 1 3.499 1 6.57v6.868C1 16.51 3.05 19.008 6.091 19z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="22"
      fill="none"
      viewBox="0 0 22 20"
    >
      <g
        id="Message"
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      >
        <path
          id="Stroke 1"
          d="m16.902 6.851-4.443 3.613c-.84.666-2.02.666-2.86 0l-4.48-3.613"
        ></path>
        <path
          id="Stroke 3"
          fillRule="evenodd"
          d="M15.909 19C18.95 19.008 21 16.51 21 13.438V6.57C21 3.499 18.95 1 15.909 1H6.09C3.05 1 1 3.499 1 6.57v6.868C1 16.51 3.05 19.008 6.091 19z"
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
